<template>
  <div class="form">
    <template v-if="mode == 'list'">
      <div class="form-search">
        <lgn-input class="form-search-input" placeholder="搜尋" v-model="searchTextView"
        :suffix="true" :suffix-icon="'el-icon-search'" :suffix-method="searchService"
        @keyup.enter.native="searchService"></lgn-input>
      </div>
      <div class="form-category">
        <button type="button" class="form-category-item" :class="{'is-active' : searchCategory == '全部'}" @click="changeCategory('全部')">
          <div class="form-category-item-img el-icon-user">
              <div class="form-category-item-img-length">{{applyServiceList['全部'].length}}</div>
          </div>
          <div class="form-category-item-text">全部 <i class="form-category-item-text-length">{{applyServiceList['全部'].length}}</i></div>
        </button>
        <button type="button" class="form-category-item" :class="{'is-active' : searchCategory == '拒絕'}" @click="changeCategory('拒絕')">
          <div class="form-category-item-img el-icon-folder-add">
              <div class="form-category-item-img-length">{{applyServiceList['拒絕'].length}}</div>
          </div>
          <div class="form-category-item-text">拒絕 <i class="form-category-item-text-length">{{applyServiceList['拒絕'].length}}</i></div>
        </button>
        <button type="button" class="form-category-item" :class="{'is-active' : searchCategory == '申請'}" @click="changeCategory('申請')">
          <div class="form-category-item-img el-icon-folder-checked">
              <div class="form-category-item-img-length">{{applyServiceList['申請'].length}}</div>
          </div>
          <div class="form-category-item-text">申請 <i class="form-category-item-text-length">{{applyServiceList['申請'].length}}</i></div>
        </button>
        <button type="button" class="form-category-item" :class="{'is-active' : searchCategory == '開通'}" @click="changeCategory('開通')">
          <div class="form-category-item-img el-icon-folder-delete">
              <div class="form-category-item-img-length">{{applyServiceList['開通'].length}}</div>
          </div>
          <div class="form-category-item-text">開通 <i class="form-category-item-text-length">{{applyServiceList['開通'].length}}</i></div>
        </button>
      </div>
      <div class="paca-table" :key="tableKey">
        <div class="paca-table__header">
          <button type="button" class="paca-table__header-item item-column column-apply-date" @click="sortByList('created_at')">
            申請時間 
            <i type="button" class="item-column-sorting" :class="this.sortItem == 'created_at' ? (this.sortDirection == 'ASC' ? 'el-icon-caret-bottom' : 'el-icon-caret-top') : 'el-icon-d-caret'"></i>
          </button>
          <div class="paca-table__header-item item-column column-nickname">暱稱</div>
          <div class="paca-table__header-item item-column column-email">信箱</div>
          <div class="paca-table__header-item item-column column-company-name">公司名稱</div>
          <div class="paca-table__header-item item-column column-tax-id">統編</div>
          <button type="button" class="paca-table__header-item item-column column-service" @click="sortByList('services_title')">
            服務
            <i class="item-column-sorting" :class="this.sortItem == 'services_title' ? (this.sortDirection == 'ASC' ? 'el-icon-caret-bottom' : 'el-icon-caret-top') : 'el-icon-d-caret'"></i>
          </button>
          <div class="paca-table__header-item item-column column-status">狀態</div>
          <div class="paca-table__header-item item-column column-company-address">營業地址</div>
          <div class="paca-table__header-item item-column column-action"></div>
        </div>
        <div class="paca-table__body">
          <template v-for="(item, index) in applyServiceListView['全部']">
            <div class="paca-table__body-col" :key="index" v-if="showOnCategory(item) && showOnSearch(item)">
                <div class="paca-table__body-col-list">
                  <div class="paca-table__body-col-list-item item-column column-apply-date">{{item.created_at.split(" ")[0]}}</div>
                  <div class="paca-table__body-col-list-item item-column column-nickname">
                    <i class="column-nickname-text">{{item.nickname}}
                      <button type="button" class="column-nickname-text-icon el-icon-chat-line-square" @click="openDetailItem(item)" v-if="item.remark && item.remark.length != 0"></button>
                    </i>
                  </div>
                  <div class="paca-table__body-col-list-item item-column column-email">
                    <button type="button" class="column-email-button" @click="gotoDetail(item.email)">{{item.email}}</button>
                  </div>
                  <div class="paca-table__body-col-list-item item-column column-company-name">{{item.company_name}}</div>
                  <div class="paca-table__body-col-list-item item-column column-tax-id">{{item.tax_id}}</div>
                  <div class="paca-table__body-col-list-item item-column column-service">{{serviceMapping[item.services_title]}}</div>
                  <div class="paca-table__body-col-list-item item-column column-status">
                    <el-select v-model="item.status" @change="updateServiceStatus(item)" :disabled="item.status == 1">
                      <el-option v-for="(serviceItem, serviceIndex) in serviceStatusList" :key="`${index}_${serviceIndex}`" :label="serviceItem.label" :value="serviceItem.value"></el-option>
                    </el-select>
                  </div>
                  <!-- <div class="paca-table__body-col-list-item item-column column-end-date">{{item.end_date}}</div> -->
                  <div class="paca-table__body-col-list-item item-column column-company-address">{{item.company_address}}</div>
                  <div class="paca-table__body-col-list-item item-column column-action">
                    <button type="button" class="column-action-icon el-icon-document" @click="openDetailItem(item)"></button>
                  </div>
                </div>
            </div>
          </template>
        </div>
      </div>
    </template>
    <div class="form-detail" v-else>
      <div class="form-detail-desckop" v-if="screen == 'desckop'">
        <div class="form-detail-desckop-top">
          <button type="button" class="form-detail-desckop-top-button main-button" @click="backList"><i class="el-icon-back"></i>返回</button>
        </div>
        <div class="form-detail-desckop-group">
          <div class="form-detail-desckop-group-title">申請資訊</div>
          <div class="form-detail-desckop-group-content">
            <div class="form-detail-desckop-group-content-item">
              <div class="form-detail-desckop-group-content-item-label">暱稱</div>
              <div class="form-detail-desckop-group-content-item-value">{{detailItem.nickname}}</div>
            </div>
            <div class="form-detail-desckop-group-content-item">
              <div class="form-detail-desckop-group-content-item-label">信箱</div>
              <div class="form-detail-desckop-group-content-item-value">{{detailItem.email}}</div>
            </div>
            <div class="form-detail-desckop-group-content-item">
              <div class="form-detail-desckop-group-content-item-label">公司名稱</div>
              <div class="form-detail-desckop-group-content-item-value">{{detailItem.company_name}}</div>
            </div>
            <div class="form-detail-desckop-group-content-item">
              <div class="form-detail-desckop-group-content-item-label">統一編號</div>
              <div class="form-detail-desckop-group-content-item-value">{{detailItem.tax_id}}</div>
            </div>
            <div class="form-detail-desckop-group-content-item">
              <div class="form-detail-desckop-group-content-item-label">公司登記地址</div>
              <div class="form-detail-desckop-group-content-item-value">{{detailItem.company_address}}</div>
            </div>
            <div class="form-detail-desckop-group-content-item">
              <div class="form-detail-desckop-group-content-item-label">申請項目</div>
              <div class="form-detail-desckop-group-content-item-value">{{serviceMapping[detailItem.services_title]}}</div>
            </div>
            <div class="form-detail-desckop-group-content-item">
              <div class="form-detail-desckop-group-content-item-label">申請時間</div>
              <div class="form-detail-desckop-group-content-item-value">{{detailItem.created_at}}</div>
            </div>
          </div>
        </div>
        <div class="form-detail-desckop-group">
          <div class="form-detail-desckop-group-title">審核結果</div>
          <div class="form-detail-desckop-group-content">
            <div class="form-detail-desckop-group-content-item">
              <div class="form-detail-desckop-group-content-item-label apply">狀態</div>
              <el-select class="form-detail-desckop-group-content-item-value item-select" v-model="detailItem.status">
                <el-option v-for="(serviceItem, serviceIndex) in serviceStatusList" :key="`${serviceIndex}`" :label="serviceItem.label" :value="serviceItem.value"></el-option>
              </el-select>
            </div>
            <div class="form-detail-desckop-group-content-item">
              <div class="form-detail-desckop-group-content-item-label apply">備註</div>
              <textarea class="form-detail-desckop-group-content-item-value textarea" v-model="detailItem.remark"></textarea>
            </div>
            <div class="form-detail-desckop-group-content-footer">
              <button type="button" class="main-button" @click="updateServiceStatus(detailItem)">確認</button>
            </div>
          </div>
        </div>
      </div>
      <div class="form-detail-mobile" v-else>
        <div class="form-detail-mobile__header">
              <button type="button" class="form-detail-mobile__header-icon el-icon-back" @click="backList"></button>
              <div class="form-detail-mobile__header-text">審核資料</div>
          </div>
          <div class="form-detail-mobile__body">
              <div class="form-detail-mobile__body-group">
                <div class="form-detail-mobile__body-group-title">車籍資訊</div>
                <div class="form-detail-mobile__body-group-content">
                  <div class="form-detail-mobile__body-group-content-item">
                    <div class="form-detail-mobile__body-group-content-item-label">暱稱</div>
                    <div class="form-detail-mobile__body-group-content-item-value">{{detailItem.nickname}}</div>
                  </div>
                  <div class="form-detail-mobile__body-group-content-item">
                    <div class="form-detail-mobile__body-group-content-item-label">信箱</div>
                    <div class="form-detail-mobile__body-group-content-item-value">{{detailItem.email}}</div>
                  </div>
                  <div class="form-detail-mobile__body-group-content-item">
                    <div class="form-detail-mobile__body-group-content-item-label">公司名稱</div>
                    <div class="form-detail-mobile__body-group-content-item-value">{{detailItem.company_name}}</div>
                  </div>
                  <div class="form-detail-mobile__body-group-content-item">
                    <div class="form-detail-mobile__body-group-content-item-label">統一編號</div>
                    <div class="form-detail-mobile__body-group-content-item-value">{{detailItem.tax_id}}</div>
                  </div>
                  <div class="form-detail-mobile__body-group-content-item">
                    <div class="form-detail-mobile__body-group-content-item-label">公司登記地址</div>
                    <div class="form-detail-mobile__body-group-content-item-value">{{detailItem.company_address}}</div>
                  </div>
                  <div class="form-detail-mobile__body-group-content-item">
                    <div class="form-detail-mobile__body-group-content-item-label">申請項目</div>
                    <div class="form-detail-mobile__body-group-content-item-value">{{serviceMapping[detailItem.services_title]}}</div>
                  </div>
                  <div class="form-detail-mobile__body-group-content-item">
                    <div class="form-detail-mobile__body-group-content-item-label">申請時間</div>
                    <div class="form-detail-mobile__body-group-content-item-value">{{detailItem.created_at}}</div>
                  </div>
                </div>
              </div>
              <div class="form-detail-mobile__body-group">
                <div class="form-detail-mobile__body-group-title">審核結果</div>
                <div class="form-detail-mobile__body-group-content">
                  <div class="form-detail-mobile__body-group-content-item">
                    <div class="form-detail-mobile__body-group-content-item-label apply">狀態</div>
                    <el-select class="form-detail-mobile__body-group-content-item-value item-select" v-model="detailItem.status">
                      <el-option v-for="(serviceItem, serviceIndex) in serviceStatusList" :key="`${serviceIndex}`" :label="serviceItem.label" :value="serviceItem.value"></el-option>
                    </el-select>
                  </div>
                  <div class="form-detail-mobile__body-group-content-item">
                    <div class="form-detail-mobile__body-group-content-item-label apply">備註</div>
                    <textarea class="form-detail-mobile__body-group-content-item-value textarea" v-model="detailItem.remark"></textarea>
                  </div>
                  <div class="form-detail-mobile__body-group-content-footer">
                    <button type="button" class="main-button" @click="updateServiceStatus(detailItem)">確認</button>
                  </div>
                </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import lgnInput from '@/lgnComponents/lgnInput/lgnInput.vue'
import * as api from '@/script/apiService/api.js'
export default {
  name: "adminForm",
  components: {
    lgnInput
  },
  data(){
    return {
      serviceStatusMapping: {
        '0': '申請中',
        '1': '已開通',
        '2': '已拒絕',
      },
      serviceStatusList: [
        {label: '已拒絕', value: 2},
        {label: '申請中', value: 0},
        {label: '已開通', value: 1}
      ],
      applyServiceList: {
        "全部": [],
        "申請": [],
        "開通": [],
        "拒絕": []
      },
      applyServiceListView: {
        "全部": [],
        "申請": [],
        "開通": [],
        "拒絕": []
      },
      searchText: '',
      searchTextView: '',
      searchCategory: '申請',
      serviceMapping: {
        'NTP Services Reports': '新北報表',
        'Services Tokens': '憑證管理'
      },
      mode: 'list',
      detailItem: {},
      screen: 'desckop',
      tableKey: 0,
      sortItem: 'created_at',
      sortDirection: 'ASC'
    }
  },
  methods: {
    changeCategory(item){
      this.searchCategory = item;
      if(this.searchText.length != 0){
        this.searchService();
      }
    },
    async getServiceList(){
      let res = await api.postServiceList();
      if(!res.error_status){
        let tempList = {
          "全部": [],
          "拒絕": [],
          "申請": [],
          "開通": []
        };
        res.forEach(function(item){
          tempList['全部'].push(item);
          if(item.status == 0){
            tempList['申請'].push(item);
          } else if(item.status == 1){
            tempList['開通'].push(item);
          } else if(item.status == 2){
            tempList['拒絕'].push(item);
          }
        }.bind(this));
        this.applyServiceList = JSON.parse(JSON.stringify(tempList));
        this.applyServiceListView = JSON.parse(JSON.stringify(tempList));
      } else if(res.error_status != '401' && res.error_status != '504'){
        this.$message.error({
          showClose: true,
          duration: 2500,
          message: "發生錯誤!"
        })
      }
    },
    async updateServiceStatus(item){
      let data = {
        id: item.id,
        status: item.status,
        remark: item.remark
      }
      let res = await api.putServiceStats(data);
      if(!res.error_status){
        await this.getServiceList();
        this.mode = 'list';
      } else if(res.error_status != '401' && res.error_status != '504'){
        this.$message.error({
          duration: 2500,
          showClose: true,
          message: "發生錯誤!"
        })
      }
    },
    searchService(){
      this.searchText = this.searchTextView;
    },
    openDetailItem(item){
      this.detailItem = JSON.parse(JSON.stringify(item));
      this.mode = 'detail';
      if(window.innerWidth <= 480){
        this.screen = 'mobile';
      } else {
        this.screen = 'desckop';
      }
    },
    backList(){
      this.mode = 'list';
    },
    sortByList(item){
      if(this.sortItem != item){
        this.sortItem = item;
        this.sortDirection = 'ASC';
        this.applyServiceListView['全部'].sort(function(a, b){
          if(a[this.sortItem] < b[this.sortItem]){
            return 1
          }
          if(a[this.sortItem] > b[this.sortItem]){
            return -1
          }
          return 0
        }.bind(this));
      } else if(this.sortDirection == 'ASC') {
        this.sortDirection = 'DESC';
        this.applyServiceListView['全部'].sort(function(a, b){
          if(a[this.sortItem] < b[this.sortItem]){
            return -1
          }
          if(a[this.sortItem] > b[this.sortItem]){
            return 1
          }
          return 0
        }.bind(this));
      } else if(this.sortDirection == 'DESC') {
        this.sortDirection = 'ASC';
        this.applyServiceListView['全部'].sort(function(a, b){
          if(a[this.sortItem] < b[this.sortItem]){
            return 1
          }
          if(a[this.sortItem] > b[this.sortItem]){
            return -1
          }
          return 0
        }.bind(this));
      }
    },
    showOnCategory(item){
      if(this.searchCategory == '全部'){
        return true
      } else if(this.searchCategory == '申請' && item.status == '0'){
        return true
      } else if(this.searchCategory == '開通' && item.status == '1' ){
        return true
      } else if(this.searchCategory == '拒絕' && item.status == '2'){
        return true
      } else {
        return false
      }
    },
    showOnSearch(item){
      let searchText = this.searchText;
      if(item.tax_id.indexOf(searchText) != -1){
        return true
      } else if(item.email.indexOf(searchText) != -1){
        return true
      } else if(item.company_name.indexOf(searchText) != -1){
        return true
      } else {
        return false
      }
    },
    gotoDetail(email){
        this.$router.push({
            name: 'Complex',
            params: {
                email: email
            }
        })
    }
  },
  computed: {
    
  },
  async activated(){
    this.getServiceList();
  }
}
</script>